import React, { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";

const DEV_TEST_NUMBERS = {
  "+918179607738": "123456", // existing test
  "+910123456781": "000000", // extra test
};

const normalizePhone = (num) => {
  if (!num) return "";
  const digits = num.replace(/\D/g, "");
  if (!digits) return "";
  if (digits.startsWith("91")) return `+${digits}`;
  return `+91${digits}`;
};

const OtpLoginPage = () => {
  const [mobile, setMobile] = useState("");
  const [otp, setOtp] = useState("");
  const [sending, setSending] = useState(false);
  const [showOtpBox, setShowOtpBox] = useState(false);
  const confirmationRef = useRef(null);
  const navigate = useNavigate();

  // -----------------------------------
  // 1️⃣ SEND OTP
  // -----------------------------------
  const handleSendOtp = async (e) => {
    e.preventDefault();

    const phoneE164 = normalizePhone(mobile);
    const digits = mobile.replace(/\D/g, "");

    if (!digits) {
      alert("Please enter mobile number");
      return;
    }

    // ✅ ADMIN LOGIN BYPASS
    if (digits === "8179607738") {
      alert("✅ Admin login bypass successful!");
      localStorage.setItem("supplierMobile", digits);
      localStorage.setItem("cc_auth", "true");
      localStorage.setItem("cc_role", "admin");
      localStorage.setItem("cc_loginAt", String(Date.now()));
      navigate("/shop", { replace: true });
      return;
    }

    // ✅ DEV TEST NUMBERS (no Firebase)
    if (DEV_TEST_NUMBERS[phoneE164]) {
      localStorage.setItem("cc_role", "dev");
      alert(`This is a DEV test number. Please enter test OTP: ${DEV_TEST_NUMBERS[phoneE164]}`);
      setShowOtpBox(true);
      return;
    }

    // ✅ REAL FIREBASE OTP FLOW
    try {
      setSending(true);
      const appVerifier = window.recaptchaVerifier || null;
      const auth = window.firebaseAuth || null;

      if (!auth || !appVerifier) {
        alert("Firebase OTP not configured in this environment.");
        return;
      }

      const confirmation = await auth.signInWithPhoneNumber(phoneE164, appVerifier);
      confirmationRef.current = confirmation;
      setShowOtpBox(true);
    } catch (err) {
      console.error("OTP send failed:", err);
      alert("Failed to send OTP");
    } finally {
      setSending(false);
    }
  };

  // -----------------------------------
  // 2️⃣ VERIFY OTP
  // -----------------------------------
  const handleVerifyOtp = async () => {
    const phoneE164 = normalizePhone(mobile);
    const digits = mobile.replace(/\D/g, "");

    // ✅ DEV TEST OTP VERIFY
    if (DEV_TEST_NUMBERS[phoneE164]) {
      const entered = String(otp || "").trim();
      const expected = String(DEV_TEST_NUMBERS[phoneE164]).trim();

      if (!entered) {
        alert("Please enter the OTP shown.");
        return;
      }

      if (entered === expected) {
        localStorage.setItem("supplierMobile", digits);
        localStorage.setItem("cc_auth", "true");
        localStorage.setItem("cc_role", "user");
        localStorage.setItem("cc_loginAt", String(Date.now()));
        navigate(`/manage?supplier=${digits}`, { replace: true });
        return;
      } else {
        alert(`Invalid DEV test OTP. Entered: ${entered}, Expected: ${expected}`);
        return;
      }
    }

    // ✅ REAL FIREBASE VERIFY
    if (!confirmationRef.current) {
      alert("Please request an OTP first.");
      return;
    }

    try {
      await confirmationRef.current.confirm(otp);
      localStorage.setItem("supplierMobile", digits);
      localStorage.setItem("cc_auth", "true");
      localStorage.setItem("cc_role", "user");
      localStorage.setItem("cc_loginAt", String(Date.now()));
      navigate(`/upload?supplier=${digits}`, { replace: true });
    } catch (err) {
      console.error("OTP verification failed:", err);
      alert("Invalid OTP, please try again.");
    }
  };

  // -----------------------------------
  // 3️⃣ RENDER UI
  // -----------------------------------
  return (
    <div
      style={{
        minHeight: "100vh",
        background: "transparent",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "20px",
      }}
    >
      <div
        style={{
          background: "#fff",
          padding: "30px 35px 40px",
          borderRadius: "16px",
          boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
          maxWidth: "480px",
          width: "100%",
        }}
      >
        <h2
          style={{
            textAlign: "center",
            marginBottom: "24px",
            color: "#6A1B1A",
          }}
        >
          📱 Supplier OTP Login
        </h2>

        {/* Mobile input */}
        <input
          type="text"
          placeholder="Enter mobile number"
          value={mobile}
          onChange={(e) => setMobile(e.target.value)}
          style={{
            width: "100%",
            padding: "10px",
            marginBottom: "15px",
            border: "1px solid #ccc",
            borderRadius: "6px",
            fontSize: "16px",
          }}
        />

        <button
          onClick={handleSendOtp}
          disabled={sending}
          style={{
            width: "100%",
            padding: "12px",
            background: "#8B4442",
            color: "#fff",
            border: "none",
            borderRadius: "6px",
            fontSize: "16px",
            cursor: "pointer",
            marginBottom: "16px",
          }}
        >
          {sending ? "Sending..." : "Send OTP"}
        </button>

        {/* OTP box appears only after send */}
        {showOtpBox && (
          <>
            <input
              type="text"
              placeholder="Enter OTP"
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
              style={{
                width: "100%",
                padding: "10px",
                marginBottom: "15px",
                border: "1px solid #ccc",
                borderRadius: "6px",
                fontSize: "16px",
              }}
            />
            <button
              onClick={handleVerifyOtp}
              style={{
                width: "100%",
                padding: "12px",
                background: "green",
                color: "#fff",
                border: "none",
                borderRadius: "6px",
                fontSize: "16px",
                cursor: "pointer",
              }}
            >
              Verify OTP
            </button>
          </>
        )}

        <p style={{ marginTop: "15px", textAlign: "center" }}>
          Not yet registered?{" "}
          <a href="/register" style={{ color: "#8B4442" }}>
            Register Supplier
          </a>
        </p>
      </div>
    </div>
  );
};

export default OtpLoginPage;
